export const INFORMATION_REQUEST = 'INFORMATION_REQUEST';
export const INFORMATION_SUCCESS = 'INFORMATION_SUCCESS';
export const INFORMATION_FAILURE = 'INFORMATION_FAILURE';
